/**
 * Dev GraphQL Links
 *
 * Development-only links to GraphQL POC pages.
 * Only shown when GraphQL feature flags are enabled.
 */

import React from 'react';
import { useHistory } from 'react-router-dom';

import { useFeatureFlags } from 'components/providers/FeatureFlagProvider';

import styles from 'components/pages/graphqlPoc/GraphQLPoc.module.scss';

interface GraphQLLink {
  /** Feature flag gating the link, or null for links that are always shown. */
  flag: string | null;
  label: string;
  path: string;
}

const GRAPHQL_LINKS: GraphQLLink[] = [
  { flag: null, label: 'POC Page', path: '/graphql-poc' },
  { flag: 'graphqlFetch', label: 'GQL Fetch', path: '/graphql-poc/fetch' },
  { flag: 'graphqlGraphqlRequest', label: 'GQL Request', path: '/graphql-poc/graphql-request' },
  { flag: 'graphqlUrql', label: 'GQL urql', path: '/graphql-poc/urql' },
  { flag: 'graphqlApollo', label: 'GQL Apollo', path: '/graphql-poc/apollo' },
];

const DevGraphQLLinks: React.FC = () => {
  const history = useHistory();
  const { features, isActive } = useFeatureFlags();

  if (!isActive()) {
    return null;
  }

  // Show always-on links plus any whose feature flag is enabled.
  const visibleLinks = GRAPHQL_LINKS.filter(
    link => link.flag === null || features[link.flag as keyof typeof features]
  );

  // Only the always-on "POC Page" link remains: nothing flag-gated is enabled.
  if (visibleLinks.length <= 1) {
    return null;
  }

  return (
    <div className={styles.devLinks}>
      {visibleLinks.map(link => (
        <button
          key={link.path}
          type="button"
          className={styles.devLink}
          onClick={() => history.push(link.path)}
        >
          {link.label}
        </button>
      ))}
    </div>
  );
};

export default DevGraphQLLinks;
